import React from 'react';
import { ShieldAlert, X } from 'lucide-react';
import { BreakGlassGrant } from '../../services/breakGlass';

interface BreakGlassBannerProps {
  grant: BreakGlassGrant;
  onEnd: () => void;
  detail?: string;
  warning?: string;
  floating?: boolean;
}

const formatTime = (ms: number) =>
  new Date(ms).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

export const BreakGlassBanner: React.FC<BreakGlassBannerProps> = ({ grant, onEnd, detail, warning, floating }) => {
  const body = (
    <div
      role="status"
      data-testid="break-glass-banner"
      className={`px-4 py-3 bg-amber-50 border border-amber-200 rounded-xl flex items-center justify-between gap-4 ${floating ? 'shadow-lg' : ''}`}
    >
      <div className="flex items-center gap-2 text-amber-800 text-sm min-w-0">
        <ShieldAlert size={16} className="text-amber-500 shrink-0" />
        <span className="font-semibold">Break-glass access: read-only, audited</span>
        {detail && <span className="text-amber-700 truncate">· {detail}</span>}
        <span className="text-amber-600 text-xs whitespace-nowrap">until {formatTime(grant.expiresAt)}</span>
        {warning && <span className="text-red-600 text-xs">{warning}</span>}
      </div>
      <button
        onClick={onEnd}
        className="flex items-center gap-1.5 text-xs font-bold text-amber-700 hover:text-amber-900 transition-colors shrink-0"
      >
        <X size={14} /> End
      </button>
    </div>
  );
  if (!floating) return <div className="mb-4">{body}</div>;
  return <div className="fixed top-3 left-1/2 -translate-x-1/2 z-[100] max-w-[720px] w-[calc(100%-2rem)]">{body}</div>;
};
